/*
  The one place the site's navigation lives. The desktop bar, the mobile menu
  and the footer all render this list, so the two link lists can never drift
  apart again. Labels are shell paths on purpose - the terminal feel comes from
  the wording, not from a monospace typeface.
*/

export const NAV_LINKS = [
  { to: "/", label: "./whoami" },
  { to: "/projects", label: "./projects" },
  { to: "/cve", label: "./research" },
  { to: "/writeup", label: "./writeups" },
  { to: "/workshops", label: "./workshops" },
  { to: "/certifications", label: "./certs" },
];

/* "/" matches every route unless the NavLink is told to match it exactly */
export const isExact = (to) => to === "/";

export default NAV_LINKS;
